import React from "react";
import { 
    Flex, 
    Stack, 
    Heading, 
    Text, 
    Box, 
    Button, 
    HStack, 
    FormControl, 
    FormLabel, 
    Input, 
    NumberInput, 
    NumberInputField, 
    NumberInputStepper, 
    NumberIncrementStepper, 
    NumberDecrementStepper, 
    useToast
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars"

function AddReviewsScreen() {
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')) === null) {
        window.location.replace("/unauthorized");
    }
    const userid = parseInt(useParams().userid);
    const productid = parseInt(useParams().productid);
    const theToken = localStorage.getItem('token');

    // set add reviews toast message
    const addReviewToast = useToast();
    const id = 'addReview-toast';
    return (
        <Formik
            initialValues={{
                review: '',
            }}
            validationSchema={Yup.object({
                review: Yup.string()
                .required('Reviews is required'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                const custReview = String(values.review);
                const inRating = document.getElementById('rating');
                const rating = parseInt(inRating.value);
                // form data for image uploading
                const formData = new FormData();
                let reviewImgFile = document.getElementById('reviewImg').files[0];
                formData.append('image', reviewImgFile);
                if (typeof reviewImgFile == 'undefined') {
                    reviewImgFile = '';                   
                }
                // if there is no image selected
                if (typeof reviewImgFile == 'string') {
                    const reviewRequestBody = {
                        review: custReview,
                        rating,
                        reviewImgUrl: reviewImgFile,
                        userid,
                    };
                    // access backend to post review without image
                    axios.post(`${CommonVars.API_URL}/product/${productid}/review`, reviewRequestBody, {
                        headers: { Authorization: `Bearer ${theToken}` },
                    })
                    .then(() => {
                        setSubmitting(false);
                        if(!addReviewToast.isActive(id)) {
                            addReviewToast({
                                id,
                                title: 'Review Posted!',
                                description: "Your review is posted successfully!",
                                status: 'success',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        resetForm();
                        setTimeout(() => {
                            window.location.replace(`/product/${productid}/reviews`);
                        }, 1500);
                    })
                    .catch((error) => {
                        if(!addReviewToast.isActive(id)) {
                            addReviewToast({
                                id,
                                title: 'Review Posting Failed.',
                                description: "Something went wrong with posting...",
                                status: 'error',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        console.log(error);
                    });
                } else if (typeof reviewImgFile == 'object') {
                    // upload the image to cloudinary first
                    axios.post(`${CommonVars.API_URL}/upload-reviewImg`, 
                        formData,
                        { headers: { Authorization: `Bearer ${theToken}` } },
                    )
                    .then((res) => {
                        const reviewImgUploaded = res.data;
                        // prepare the request body
                        const reviewRequestBody2 = {
                            review: custReview,
                            rating,
                            reviewImgUrl: reviewImgUploaded,
                            userid,
                        };
                        // access backend to post review
                        axios.post(`${CommonVars.API_URL}/product/${productid}/review`, 
                            reviewRequestBody2, 
                            { headers: { Authorization: `Bearer ${theToken}` } },
                        )
                        .then(() => {
                            setSubmitting(false);
                            if(!addReviewToast.isActive(id)) {
                                addReviewToast({
                                    id,
                                    title: 'Review Posted!',
                                    description: "Your review is posted successfully!",
                                    status: 'success',
                                    position: 'top',
                                    duration: 2000,
                                    isClosable: true,
                                });
                            }
                            resetForm();
                            setTimeout(() => {
                                window.location.replace(`/product/${productid}/reviews`);
                            }, 1500);  
                        })
                        .catch((error) => {
                            if(!addReviewToast.isActive(id)) {
                                addReviewToast({
                                    id,
                                    title: 'Review Posting Failed.',
                                    description: "Something went wrong with posting...",
                                    status: 'error',
                                    position: 'top',
                                    duration: 2000,
                                    isClosable: true,
                                });
                            }
                            console.log(error);
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                }
            }}
        >
            {props => (
                <Flex
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                            <Heading fontSize={'4xl'}>Add a Product Review</Heading>
                            <Text fontSize={'lg'} color={'gray.600'}>
                                Help our community by leaving a review for the product!
                            </Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            p={8}
                        >
                            <Form>
                                <Stack spacing={5}>
                                    {/* Reviews Input */}
                                    <CustomFormInput
                                        label="Product Review" 
                                        name="review" 
                                        type="text"
                                        placeholder="Enter Review"
                                    />
                                    {/* Reviews Rating */}
                                    <FormControl>
                                        <FormLabel>Review Rating</FormLabel>
                                        <NumberInput size='sm' maxW={20} defaultValue={1} min={1} max={5} required>
                                            <NumberInputField id="rating" />
                                            <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                            </NumberInputStepper>
                                        </NumberInput>
                                    </FormControl>
                                    {/* Product Review Image Input */}
                                    <FormControl>
                                        <FormLabel>Product Review Image</FormLabel>
                                        <Input id="reviewImg" placeholder='medium size' size='md' type={'file'} variant={'flushed'}/>
                                    </FormControl>
                                    <HStack spacing='20px' pt={2} pb={1}>
                                        <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Add Review'}</Button>
                                        <Button type='reset'>Reset</Button>
                                    </HStack>
                                </Stack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    );
}

export default AddReviewsScreen;